angular.module('amount-commission', [])
    .service('AmountCommission', AmountCommission);

AmountCommission.$inject = ['$rootScope', '$stateParams', 'configs', 'ClientCards', 'Pay', 'PortalApi', '$timeout', '$translate'];

function AmountCommission($rootScope, $stateParams, configs, ClientCards, Pay, PortalApi, $timeout, $translate) {
    var BigNumber = require('bignumber.js'),
        tariffConfig = configs.payments_config;

    var amountCommission = {
        data:{},
        tariffs_loader: false,
        countAmount: function (type) {
            if(isFinite(Pay.subsidyObj.subsidy)){

                if(Pay.subsidyObj.subsidy == null || Pay.subsidyObj.subsidy < 0){
                    Pay.subsidyObj.subsidy = 0;
                }

                Pay.subsidyObj.subsidyNum = new BigNumber(Pay.subsidyObj.subsidy || 0).round(2, BigNumber.ROUND_HALF_CEIL).toFixed(2);
            }

            if(Pay.info.category !== 37) {

                if (Pay.service.amount_min || Pay.service.amount_max) {
                    if (Pay.data.amountInput < Pay.service.amount_min) {
                        amountCommission.data.limitSummError = true;
                    }
                }
            }

            amountCommission.checkCountAmount();

            if ($stateParams.serviceId == tariffConfig.service.CreditFUIB) {
                amountCommission.changeCommission();
            }

            if (Pay.subsidyObj.subsidy) {
                amountCommission.changingPayAmountWithSubsidy();
                Pay.amount = Pay.AmountSubsidyDif;
            }

            // if (Pay.amount > 0) {
            $timeout(function() {
                amountCommission.localCalcCommission(type);
            }, 100);
            // }
        },
        checkCountAmount: function() {
            if (+Pay.amountInput !== 0) {
                if (isFinite(Pay.amountInput)) {
                    Pay.amount = new BigNumber(Pay.amountInput).round(2, BigNumber.ROUND_HALF_CEIL).toFixed(2);
                }
            } else {
                if (Pay.selectedProduct.meters) {
                    Pay.selectedProduct.meters.forEach(function(meter) {
                        if (!meter.tariff || !meter.current) {
                            Pay.amount = Pay.amountInput = Number(Pay.selectedProduct.amount);
                        } else {
                            $rootScope.$broadcast('Amount.checkCountAmount', meter);
                        }
                    });
                }
            }
        },
        changeCommission: function() {
            var str = '';
            var payNmb = 2625;
            if (Array.isArray(Pay.fields) && Pay.fields[0] && Pay.fields[0].value) {
                str = Pay.fields[0].value.substr(0, 4);
                if (str == payNmb) {
                    Pay.service.amount_max = 3000;
                }
            }
        },
        localCalcCommission: function(type) {
            var amount = 0;
            var commission = new BigNumber(0);
            var discount = new BigNumber(0);

            if (!$stateParams.amount) {
                if(!Pay.subsidyObj.subsidyNum){
                    amount = +Pay.AmountSubsidyDif || +Pay.amountInput || 0;
                } else{
                    amount = (+Pay.amountInput - +Pay.subsidyObj.subsidyNum).toFixed(2);
                }
            } else {
                amount = (+Pay.amountInput - +Pay.subsidyObj.subsidyNum).toFixed(2);
            }

            if (!isFinite(amount) || amount <= 0) {
                amount = 0;
            }

            Pay.commissionDescription = '';

            if (ClientCards.data.usedPrepaidCard) {
                commission = new BigNumber(0);
            } else if (type && amount > 0) {
                var data = {
                        service_id: Pay.data.serviceId,
                        amount: amount,
                        source: {
                            cardFrom : ClientCards.getSourceObj('mp')
                        }
                    };
                Pay.data.mpPreLoader = true;

                PortalApi.calculateCommission(data).then(function(response) {

                    Pay.data.mpPreLoader = false;

                    commission = Pay.commission =  response.commission;

                    Pay.amountWithCommission = Math.round((+commission + Number(amount))* 100) / 100 || 0;
                }, function(reason) {

                    Pay.data.mpPreLoader = false;
                    return $translate('NOTIFICATION.ERROR.PROCESS_PAYMENT_ERROR').then(function (translation) {
                        Pay.apiError(translation);
                    });
                });
            } else if (Pay.commissions.length && amount > 0) {
                for (var i = 0; i < Pay.commissions.length; i++) {
                    if ( Pay.commissions[i].null_for_fuib_cards &&
                        ($stateParams.url != 'p2p' && (ClientCards.data.number || ClientCards.data.id || ClientCards.data.isGAPay)) ||
                        ($stateParams.url == 'p2p' && (ClientCards.data.target.card && ClientCards.data.number || ClientCards.data.isGAPay)) ){

                        var data = {
                                service_id: Pay.data.serviceId,
                                amount: Pay.amount,
                                source: ClientCards.getSourceObj()
                            };

                        amountCommission.tariffs_loader = true;

                        PortalApi.calculateCommission(data).then(function(response) {

                            amountCommission.tariffs_loader = Pay.data.preLoader = Pay.data.mpPreLoader = false;

                            commission = Pay.commission =  response.commission;

                            Pay.amountWithCommission = Math.round((+commission + Number(amount))* 100) / 100 || 0;
                        }, function(reason) {

                            amountCommission.tariffs_loader = Pay.data.preLoader = Pay.data.mpPreLoader = false;
                            return $translate('NOTIFICATION.ERROR.PROCESS_PAYMENT_ERROR').then(function (translation) {
                                Pay.apiError(translation);
                            });
                        });
                    } else if (Pay.commissions[i].grace_period > 0) {
                        $translate('PAYMENTS_INFO.PREFERENTIAL', { days: Pay.commissions[i].grace_period }).then(function(translation) {
                            Pay.commissionDescription = translation;
                        });
                    } else {
                        if (!Pay.commissions[i].amount_from || Pay.commissions[i].amount_from <= amount) {
                            if (!Pay.commissions[i].amount_to || Pay.commissions[i].amount_to >= amount) {
                                if (Pay.commissions[i].value && Pay.commissions[i].value > 0) {
                                    Pay.commissionDescription += '' + Pay.commissions[i].value / 100 + ' грн';
                                    commission = commission.plus(Pay.commissions[i].value).dividedBy(100);
                                }

                                if (Pay.commissions[i].percentage && Pay.commissions[i].percentage > 0) {

                                    if (Pay.commissionDescription) {
                                        Pay.commissionDescription += ' + '
                                    }

                                    Pay.commissionDescription += '' + Pay.commissions[i].percentage + '%';
                                    commission = commission.plus(new BigNumber(amount).times(new BigNumber(Pay.commissions[i].percentage)).dividedBy(100));
                                }

                                if (Pay.commissions[i].value_min && Pay.commissions[i].value_min > 0) {
                                    Pay.commissionDescription += ', мин. ' + Pay.commissions[i].value_min / 100 + ' грн';

                                    if (Pay.commissions[i].value_min > commission * 100) {
                                        commission = new BigNumber(Pay.commissions[i].value_min).dividedBy(100);
                                    }
                                }

                                if (Pay.commissions[i].value_max && Pay.commissions[i].value_max > 0) {
                                    Pay.commissionDescription += ', макс. ' + Pay.commissions[i].value_max / 100 + ' грн';

                                    if (Pay.commissions[i].value_max < commission * 100) {
                                        commission = new BigNumber(Pay.commissions[i].value_max).dividedBy(100);
                                    }
                                }
                                break;
                            }
                        }
                    }
                }
            }

            if (Pay.service.calc_discount) {
                if (ClientCards.data.number || ClientCards.data.id) {
                   let data = {
                       amount: Pay.amount * 100,
                       serviceId: Pay.data.booking.serviceId,
                       source: ClientCards.getSourceObj()
                   }

                   amountCommission.tariffs_loader = true;

                   PortalApi.bookingDiscount(data).then(function(response) {
                       amountCommission.tariffs_loader = Pay.data.preLoader = false;

                       commission = Pay.commission =  response.commission / 100;
                       discount = Pay.discount = response.discount / 100;

                        Pay.amountWithCommission = Math.round((+commission + Number(amount) - discount)* 100) / 100 || 0;
                   }, function(reason) {
                       amountCommission.tariffs_loader = false;
                       return $translate('NOTIFICATION.ERROR.PROCESS_PAYMENT_ERROR').then(function (translation) {
                           Pay.apiError(translation);
                       });
                   });
               }
            }

             if (amount > 0) {
                 if (Pay.service.use_two_step && Pay.selectedProduct.length == 0 && Pay.selectedProduct.amountType > 0) {
                     Pay.amount = 0;
                     Pay.amountWithCommission = 0;
                 } else {
                     Pay.commission = +commission.round(2, BigNumber.ROUND_HALF_CEIL);
                     Pay.amountWithCommission = +commission.plus(amount).round(2, BigNumber.ROUND_HALF_CEIL) || 0;
                 }
            } else {
                Pay.amount = 0;
                Pay.commission = 0;
                Pay.amountWithCommission = 0;
            }
        },
        changingPayAmountWithSubsidy: function (){
            Pay.subsidyObj.subsidyNum = new BigNumber(Pay.subsidyObj.subsidy || 0).toFixed(2);

            if (Pay.subsidyObj.subsidyNum == Pay.amount
                || +Pay.subsidyObj.subsidyNum > +Pay.amount
                || (Pay.amount - Pay.subsidyObj.subsidyNum) < Pay.service.amount_min
            ) {
                amountCommission.data.limitSummError = true;
                return ;
            } else {
                amountCommission.data.limitSummError = false;

            }

            if ($stateParams.amount) {
                Pay.AmountSubsidyDif = new BigNumber(+$stateParams.amount).minus(+Pay.subsidyObj.subsidyNum).toFixed(2);
                Pay.amount = Pay.AmountSubsidyDif;
            } else {
                Pay.AmountSubsidyDif = new BigNumber(+Pay.amount).minus(+Pay.subsidyObj.subsidyNum).toFixed(2);
            }

            amountCommission.localCalcCommission();
        }
    };
    return amountCommission;
}



/*****************
 ** WEBPACK FOOTER
 ** ./app/components/amount-commission/services/amount-commission.js
 ** module id = 69
 ** module chunks = 1
 **/